export default {
      id: "svg-icon-ico-yt-usage",
      viewBox: "0 0 64 64",
      url: __webpack_public_path__ + "static/images/svg-icons.svg#svg-icon-ico-yt",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons-svg/ico-yt.svg
// module id = 33ue
// module chunks = 4